import { ChartPreferencesRecord, ChartPreferencesType } from '@trinity/chat/src/types/chart-preferences';
import { createContext } from 'react';

export type UpdateChartPreferencesOverride = (data: {
  recordId: number;
  overrideChartTypes: ChartPreferencesType[];
}) => Promise<{
  record: ChartPreferencesRecord;
}>;
export type CreateChartPreferencesRecord = (data: {
  initialChartType: ChartPreferencesType;
}) => Promise<{
  record: ChartPreferencesRecord;
}>;

export const UpdateChartPreferencesContext = createContext<UpdateChartPreferencesOverride>(null);
export const CreateChartPreferencesRecordContext = createContext<CreateChartPreferencesRecord>(null);